import { Suspense, lazy, type ComponentProps } from "react";
import type { AuthModal } from "@/components/auth/AuthModal";

const AuthModalImpl = lazy(() =>
  import("@/components/auth/AuthModal").then((m) => ({ default: m.AuthModal })),
);

/**
 * Inloggningsrutan hamtas forst nar den faktiskt oppnas. Knappar som "spara
 * favorit" eller "kontakta saljaren" kan darfor visas utan att sidan behover
 * ladda hela inloggnings- och databaskoden i forvag.
 */
export function LazyAuthModal(props: ComponentProps<typeof AuthModal>) {
  if (!props.open) return null;
  return (
    <Suspense fallback={null}>
      <AuthModalImpl {...props} />
    </Suspense>
  );
}
